import Http from "@/commons/Http";

const path = 'api/timeline';

export default {

    async save(dto, protocolId, id = ''){
        return Http.post(`${path}/${protocolId}/${id}`, dto);
    },

    async getAll(protocolId){
        return Http.get(`${path}/${protocolId}`);
    },

    async getById(id, protocolId){
        return Http.get(`${path}/${protocolId}/${id}`);
    },

    async delete(protocolId, id){
        return Http.delete(`${path}/${protocolId}/${id}`);
    },
}